import { dataReportStamp } from 'dls-icons-data'
import { createIcon } from '../common'

const IconReportStamp = /*#__PURE__*/createIcon(dataReportStamp)
export default IconReportStamp
